import { useSelector, useDispatch } from "react-redux";
import { useNavigate, NavLink } from "react-router-dom";
import RandomColorCircle from "../components/utils/RandomColorCircle";
import { logout, reset, updateUser, deleteUser } from "../features/auth/authSlice";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import { FaPencilAlt } from "react-icons/fa";
import axios from "axios";
import { useRef, useEffect } from "react";
import { countDownParser } from "../components/utils/dateParser";
import CategorieManager from "../components/CategorieManager";

import Modal from "react-bootstrap/Modal";

const API_URL =
  process.env.REACT_APP_NODE_ENV === "production"
    ? process.env.REACT_APP_BASE_URL + "/api/users/"
    : "/api/users/";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    name: user.name,
  });
  const { name } = formData;

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (name === user.name) {
      // toast.error("Change at least one field");
      setOpenEdit(false);
      return;
    } else {
      if (name.length < 3) {
        return toast.error("Insert at least 3 character");
      }

      const userData = {
        id: user._id,
        name,
      };
      try {
        await dispatch(updateUser(userData)).unwrap();
        toast.success("User successfully updated");
        setOpenEdit(false);
      } catch (error) {
        toast.error(error.message || "Error");
        console.error(error);
      }
    }
  };

  const onLogout = () => {
    dispatch(logout());
    dispatch(reset());
    navigate("/");
  };

  const [modalState, setModalState] = useState({
    deleteModal: false,
  });
    const handleShow = (modalType) => {
    setModalState((prevState) => ({
      ...prevState,
      [modalType]: true,
    }));
  };
  const handleClose = (modalType) => {
  setModalState((prevState) => ({
    ...prevState,
    [modalType]: false,
  }));}

const handleDeleteUser = async () => {
  try {
    await dispatch(deleteUser(user._id)).unwrap();
    toast.success("Goodbye");
  } catch (error) {
    console.error(error, "delete user error");
    toast.error(error.message || "Errore");
  } finally {
    dispatch(logout());
    dispatch(reset());
    handleClose("deleteUser"); // Close modal if open
    navigate("/");
  }
}
  const [time, setTime] = useState(20);
  const [sendMailDisabled, setSendMailDisabled] = useState(false);
  const timerRef = useRef(null);

  const startCountDown = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    setTime(20); // Always reset time
    const now = Date.now();
    const resendAllowedAt = now + 5 * 1000;
    localStorage.setItem("mailResendAllowedAt", resendAllowedAt);

    timerRef.current = setInterval(() => {
      setTime((currTime) => {
        if (currTime === 0) {
          clearInterval(timerRef.current);
          localStorage.removeItem("mailResendAllowedAt");
          return 0;
        } else {
          return currTime - 1;
        }
      });
    }, 1000);
  };

  useEffect(() => {
    const allowed =
      Date.now() < Number(localStorage.getItem("mailResendAllowedAt"));
    setSendMailDisabled(allowed);
  }, [time]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const resetPasswordAction = (mail) => {
    setSendMailDisabled(true);
    axios
      .post(`${API_URL}requestPasswordReset`, { mail })
      .then((res) => {
        toast.success(<Msg />, {
          toastId: "err1",
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        startCountDown();
      })
      .catch((error) => {
        console.log(error, "evvore");
        toast.error(error.message || "Error");
        setSendMailDisabled(false);
      });
  };

  function Msg() {
    return (
      <div>
        <span>
          A password reset link has been sent to your email. Please check your
          inbox,
          <br />
          <br />
          <span
            className="text-primary"
            role="button"
            onClick={() => navigate("/login")}
          >
            <u>login</u>
          </span>{" "}
          to continue
        </span>
      </div>
    );
  }

  const [openEdit, setOpenEdit] = useState(false);

  return (
    <div className="container m-auto">
      <div className="row">
        <div className="col-12">
          <div className="mb-4 mt-0">
            <h3 className="mb-0 h4 font-weight-bolder">Impostazioni Profilo e Finanza</h3>
            <p className="text-secondary text-sm mb-0 mt-1">
              Gestisci il tuo profilo, la sicurezza e le categorie di spesa.
            </p>
          </div>
        </div>
      </div>

      <div className="row gutters-sm">
        <div className="col-12 col-lg-8">
          {/* Profile card */}
          <div className="card mb-4">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h6 className="mb-0">Profilo</h6>
                {!openEdit && (
                  <button
                    className="btn btn-outline-dark btn-sm mb-0"
                    onClick={() => setOpenEdit(true)}
                  >
                    <FaPencilAlt size={13} />
                  </button>
                )}
              </div>

              {!openEdit ? (
                <div className="row align-items-center">
                  <div className="col-auto">
                    <RandomColorCircle
                      letter={user?.email}
                      email={user?.email}
                      className={"circle-large"}
                    />
                  </div>
                  <div className="col">
                    <h5 className="mb-0">{user.name}</h5>
                    <p className="text-secondary text-sm mb-0">{user.email}</p>
                  </div>
                  <div className="col-auto">
                    <button
                      className="btn btn-outline-dark mb-0"
                      onClick={() => onLogout()}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              ) : (
                <Form onSubmit={onSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      id="name"
                      name="name"
                      value={name}
                      placeholder="Name"
                      onChange={onChange}
                    />
                  </Form.Group>
                  <div className="d-flex align-item-center justify-content-end text-center gap-3">
                    <button
                      type="button"
                      className="btn btn-outline-dark"
                      onClick={() => setOpenEdit(false)}
                    >
                      <p className="m-0">Cancel</p>
                    </button>
                    <button type="submit" className="btn bg-gradient-dark w-25">
                      <p className="m-0">Save</p>
                    </button>
                  </div>
                </Form>
              )}
            </div>
          </div>

          {/* Categorie di spesa card (CRUD) */}
          <CategorieManager />
        </div>

        <div className="col-12 col-lg-4">
          {/* Security card */}
          <div className="card mb-4">
            <div className="card-body">
              <h6 className="mb-3">Sicurezza</h6>
              <div className="d-flex align-items-center justify-content-between mb-3">
                <span className="text-secondary text-sm">Password</span>
                <span className="text-dark text-sm">°°°°°°°°°</span>
              </div>
              <button
                disabled={sendMailDisabled}
                className="btn btn-outline-dark w-100 mb-0"
                onClick={() => resetPasswordAction(user.email)}
              >
                Send reset link
              </button>
              {sendMailDisabled && (
                <small className="d-block mt-2 text-danger">
                  You can resend the next email to reset you password in{" "}
                  {countDownParser(time)} seconds
                </small>
              )}
            </div>
          </div>

          {/* Danger zone card */}
          <div className="card">
            <div className="card-body">
              <h6 className="text-danger mb-1">Zona pericolosa</h6>
              <p className="text-secondary text-sm">This action can't be undone</p>
              <button
                className="btn btn-outline-danger w-100 mb-0"
                onClick={() => handleShow("deleteUser")}
              >
                Delete account
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={modalState.deleteUser}
        onHide={() => handleClose("deleteUser")}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>
              Confirm to delete: <i>{user.name}</i>?
            </b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure to delete your account,
            <br /> <b>this action can be undone</b>{" "}
          </p>
          <div className="row mt-4 mb-3">
            <div className="col-4">
              <button
                className=" text-dark btn btn-outline-dark btn-sm mb-0 w-100"
                onClick={() => handleClose("deleteUser")}
              >
                <p className="mb-0 ">cancel</p>
              </button>
            </div>
            <div className="col-8">
              <button
                className="text-danger btn border border-1 border-danger w-100 "
                // onClick={() => dispatch(deleteSchedaSpese(scheda._id))}
                onClick={() => handleDeleteUser()}
              >
                Delete
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Profile;
